var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99334 0.728278C8.35251 -0.221938 9.69667 -0.221936 10.0558 0.728281L11.5097 4.57457C11.6651 4.9857 12.0498 5.26525 12.4889 5.286L16.5962 5.48011C17.6109 5.52807 18.0262 6.80644 17.2335 7.44167L14.0247 10.0129C13.6818 10.2878 13.5348 10.7401 13.6507 11.164L14.7353 15.1303C15.0033 16.1102 13.9158 16.9002 13.0667 16.3426L9.62977 14.0854C9.26239 13.8442 8.78679 13.8442 8.41941 14.0854L4.98244 16.3426C4.13334 16.9002 3.04589 16.1101 3.31384 15.1303L4.39845 11.164C4.51439 10.7401 4.36742 10.2878 4.02443 10.0129L0.815655 7.44166C0.0229349 6.80644 0.438306 5.52807 1.453 5.48011L5.5603 5.286C5.99934 5.26525 6.3841 4.9857 6.5395 4.57457L7.99334 0.728278Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStar);
export default __webpack_public_path__ + "static/media/FilledStar.d9d56dffd83fa3483ced31f42e4ac672.svg";
export { ForwardRef as ReactComponent };